import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  fieldGroup: {
    position: 'relative',
    padding: 20,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 20,
  },
  fieldGroupTitle: {
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    top: -17,
  },
  fullName: {
    fontSize: '1.25rem',
  },
  addBtn: {
    marginTop: 40,
  },
}));
